import React from "react";
import clsx from "clsx";
import type { HttpMethod } from "../shared/types";

/** The coloured method label of an operation (design §0.2: menu and URL bar). */
const METHOD_STYLE: Record<HttpMethod, string> = {
  GET: "bg-green/30 text-foreground",
  POST: "bg-purple/20 text-foreground",
  PUT: "bg-yellow/40 text-foreground",
  PATCH: "bg-yellow/40 text-foreground",
  DELETE: "bg-destructive/20 text-foreground",
};

export const MethodBadge = ({ method, className }: { method: HttpMethod; className?: string }) => (
  <span className={clsx("inline-flex shrink-0 items-center rounded px-1.5 py-0.5 text-headline2 font-semibold", METHOD_STYLE[method], className)}>{method}</span>
);
